{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXPDFToolbar;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCTypes, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCCustomScrollControl, WEBLib.TMSFNCUtils,
  WEBLib.Controls, WEBLib.TMSFNCCustomList, WEBLib.TMSFNCWXPDFViewer
  {$IFNDEF LCLWEBLIB}
  ,UITypes, Generics.Collections, Types
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fgl
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  //version history
  //v1.0.0.0: First Release

type
  TTMSFNCWXCustomPDFToolbar = class;

  TTMSFNCWXPDFToolbarItemRole = (trOpenFile, trFirstPage, trPreviousPage,
    trNextPage, trLastPage, trZoomIn, trZoomOut, trRotateLeft, trRotateRight,
    trCustom);

  TTMSFNCWXPDFToolbarItemRoles = set of TTMSFNCWXPDFToolbarItemRole;

  TTMSFNCWXPDFToolbarItem = class(TTMSFNCCustomListItem)
  private
    FOnCustomEvent: TNotifyEvent;
    FBitmap: TTMSFNCBitmap;
    FPDFRole: TTMSFNCWXPDFToolbarItemRole;
    procedure SetBitmap(const Value: TTMSFNCBitmap);
  public
    constructor Create(ACollection: TCollection); override;
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
  published
    property Text;
    property HorizontalTextAlign;
    property VerticalTextAlign;
    property Bitmap: TTMSFNCBitmap read FBitmap write SetBitmap;
    property PDFRole: TTMSFNCWXPDFToolbarItemRole read FPDFRole write FPDFRole default trOpenFile;
    property OnCustomEvent: TNotifyEvent read FOnCustomEvent write FOnCustomEvent;
  end;

  TTMSFNCWXPDFToolbarItems = class(TTMSFNCCustomListItems)
  private
    function GetItem(Index: Integer): TTMSFNCWXPDFToolbarItem;
    procedure SetItem(Index: Integer; const Value: TTMSFNCWXPDFToolbarItem);
  protected
    function CreateItemClass: TCollectionItemClass; override;
  public
    property Items[Index: Integer]: TTMSFNCWXPDFToolbarItem read GetItem write SetItem; default;
    function Add: TTMSFNCWXPDFToolbarItem;
    function Insert(Index: Integer): TTMSFNCWXPDFToolbarItem;
  end;

  TTMSFNCWXCustomPDFToolbar = class(TTMSFNCCustomList)
  private
    FOldLoaded: TTMSFNCWXPDFViewerLoaded;
    FOldShowPage: TTMSFNCWXPDFViewerNavigatePageEvent;
    FViewer: TTMSFNCWXPDFViewer;
    procedure SetViewer(const Value: TTMSFNCWXPDFViewer);
    function GetItems: TTMSFNCWXPDFToolbarItems;
    procedure SetItems(const Value: TTMSFNCWXPDFToolbarItems);
  protected
    function GetDocURL: string; override;
    procedure SetOrientation(const Value: TTMSFNCCustomListOrientation); override;
    function GetVersion: string; override;
    function CreateItemsCollection: TTMSFNCCustomListItems; override;
    procedure DoItemDrawContent(AGraphics: TTMSFNCGraphics; ARecT: TRectF; AItem: TTMSFNCCustomListItem); override;
    procedure DoItemClick(AItemIndex: Integer); override;
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    {$IFDEF WEBLIB}
    procedure DoDialogPDFChanged(Sender: TObject);
    procedure DoDialogFileBase64(Sender: TObject; AFileIndex: Integer; ABase64: string);
    {$ENDIF}
    procedure DoPDFLoaded(Sender: TObject; NumPages: Integer);
    procedure DoPDFShowPage(Sender: TObject; APageNumber: Integer);
    procedure ChangeButtonState(AEnabled: Boolean; AButtonRoles: TTMSFNCWXPDFToolbarItemRoles);
    procedure DisableAllButtons;
    procedure EnableDefaultButtons;
    property Items: TTMSFNCWXPDFToolbarItems read GetItems write SetItems;
    property Viewer: TTMSFNCWXPDFViewer read FViewer write SetViewer;
  public
    constructor Create(AOwner: TComponent); override;
    procedure InitializeDefault; override;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCWXPDFToolbar = class(TTMSFNCWXCustomPDFToolbar)
  protected
    procedure RegisterRuntimeClasses; override;
  published
    property AntiAliasing;
    property Appearance;
    property Items;
    property Viewer;
    property Orientation;
    property Version: string read GetVersion;
    property OnItemSelected;
    property OnItemClick;
    property OnItemBeforeDrawBackground;
    property OnItemAfterDrawBackground;
    property OnItemBeforeDrawContent;
    property OnItemAfterDrawContent;
    property OnBeforeDraw;
    property OnAfterDraw;
    property OnItemBeforeDrawText;
    property OnItemAfterDrawText;
  end;

{$IFDEF WEBLIB}
const
  TMSFNCWXPDFTOOLBAROPEN =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkZvbGRlci1PcGVuPC90aXRsZT48ZyBpZD0iSWNvbiI+P'+
  'HBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjgsMTJWOEgxNUwxMiw1SDFWMjdIMjJMMzIsMTJaTTIsNmg5LjU5bDIuNywyLjcxLjMuMjlIMjd2M0gxMUwyLDI1LjVaTTIxLjQ2LDI2SDIuODdsOC42Ny0xM0gzMC4xM1oiLz48L2c+PC9zdmc+';

  TMSFNCWXPDFTOOLBARFIRST =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm1tLVJld2luZDwvdGl0bGU+PGcgaWQ9Ikljb24iPjxwb'+
  '2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyMiA5LjEyIDMxIDIuMjggMzEgMzAuNzIgMjIgMjMuODQgMjIgOS4xMiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIyLjQgMTYuNSAyMSAzMC43MiAyMSAyLjI4IDIuOTUgMTYuMDEgMi40IDE2LjUiLz48L2c+PC9zdmc+';

  TMSFNCWXPDFTOOLBARPREV =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm1tLUJhY2s8L3RpdGxlPjxnIGlkPSJJY29uIj48cG9se'+
  'WdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iNi40IDE2LjUgMjUgMzAuNzIgMjUgMi4yOCA2Ljk1IDE2LjAxIDYuNCAxNi41Ii8+PC9nPjwvc3ZnPg==';

  TMSFNCWXPDFTOOLBARNEXT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm1tLUZvcndhcmQ8L3RpdGxlPjxnIGlkPSJJY29uIj48c'+
  'G9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMjUuNiAxNi41IDcgMzAuNzIgNyAyLjI4IDI1LjA1IDE2LjAxIDI1LjYgMTYuNSIvPjwvZz48L3N2Zz4=';

  TMSFNCWXPDFTOOLBARLAST =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPm1tLUZhc3QtRm9yd2FyZDwvdGl0bGU+PGcgaWQ9Ikljb'+
  '24iPjxwb2x5Z29uIGNsYXNzPSJjbHMtMSIgcG9pbnRzPSIxMSA5LjEyIDIgMi4yOCAyIDMwLjcyIDExIDIzLjg0IDExIDkuMTIiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMzAuNiAxNi41IDEyIDMwLjcyIDEyIDIuMjggMzAuMDUgMTYuMDEgMzAuNiAxNi41Ii8+PC9nPjwvc3ZnPg==';

  TMSFNCWXPDFTOOLBARROTLEFT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlJlcGVhdDwvdGl0bGU+PGcgaWQ9Ikljb24iIHRyYW5zZ'+
  'm9ybT0ncm90YXRlKDI3MCAxNiAxNiknPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE0LDEuMTV2MWExNCwxNCwwLDEsMCw3LC43OFYxMkgyMFYxSDMxVjJMMjEuMzQsMkExNSwxNSwwLDEsMSwxNCwxLjE1WiIvPjwvZz48L3N2Zz4=';

  TMSFNCWXPDFTOOLBARROTRIGHT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlJlZnJlc2g8L3RpdGxlPjxnIGlkPSJJY29uIiB0cmFuc'+
  '2Zvcm09J3JvdGF0ZSg5MCAxNiAxNiknPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTE4LDEuMTV2MWExNCwxNCwwLDEsMS03LC43OFYxMmgxVjFIMVYybDkuNjYsMEExNSwxNSwwLDEsMCwxOCwxLjE1WiIvPjwvZz48L3N2Zz4=';

  TMSFNCWXPDFTOOLBARZOOMIN =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlpvb20tSW48L3RpdGxlPjxnIGlkPSJJY29uIj48cGF0a'+
  'CBjbGFzcz0iY2xzLTEiIGQ9Ik0xLDEyYTExLDExLDAsMCwwLDE3LjIzLDkuMDZsOS4zNiw5LjM1YTIsMiwwLDAsMCwyLjgyLTIuODJsLTkuMzUtOS4zNkExMSwxMSwwLDEsMCwxLDEyWm0xLDBBMTAsMTAsMCwxLDEsMTIsMjIsMTAsMTAsMCwwLDEsMiwxMloiLz48cG9seWdvbiBjbGFzcz0iY2xzLTEiIHBvaW50cz0iMTMuNDQgMTEgMTMu'+
  'NDQgNCAxMyA0IDEyLjA4IDQgMTIgNCAxMiAxMSA1IDExIDUgMTEuMDggNSAxMiA1IDEyLjQ0IDEyIDEyLjQ0IDEyIDE5IDEyLjA4IDE5IDEzIDE5IDEzLjQ0IDE5IDEzLjQ0IDEyLjQ0IDIwIDEyLjQ0IDIwIDEyIDIwIDExLjA4IDIwIDExIDEzLjQ0IDExIi8+PC9nPjwvc3ZnPg==';

  TMSFNCWXPDFTOOLBARZOOMOUT =
  'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6IzNhM2EzODt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlpvb20tT3V0PC90aXRsZT48ZyBpZD0iSWNvbiI+PHBhd'+
  'GggY2xhc3M9ImNscy0xIiBkPSJNMSwxMmExMSwxMSwwLDAsMCwxNy4yMyw5LjA2bDkuMzYsOS4zNWEyLDIsMCwwLDAsMi44Mi0yLjgybC05LjM1LTkuMzZBMTEsMTEsMCwxLDAsMSwxMlptMSwwQTEwLDEwLDAsMSwxLDEyLDIyLDEwLDEwLDAsMCwxLDIsMTJaIi8+PHJlY3QgY2xhc3M9ImNscy0xIiB4PSI2IiB5PSIxMSIgd2lkdGg9IjEz'+
  'IiBoZWlnaHQ9IjEuNSIvPjwvZz48L3N2Zz4=';
{$ENDIF}

implementation

{$R TMSFNCWXPDFToolbar.res}

{$IFDEF WEBLIB}
uses
  WEBLib.Dialogs;
{$ENDIF}

type
  TTMSFNCWXPDFViewerOpen = class(TTMSFNCWXPDFViewer);
  TTMSFNCCustomListOpen = class(TTMSFNCCustomList);

{ TTMSFNCWXPDFToolbarItem }

procedure TTMSFNCWXPDFToolbarItem.Assign(Source: TPersistent);
begin
  inherited;
  if Source is TTMSFNCWXPDFToolbarItem then
  begin
    PDFRole := (Source as TTMSFNCWXPDFToolbarItem).PDFRole;
    Bitmap.Assign((Source as TTMSFNCWXPDFToolbarItem).Bitmap);
  end;
end;

constructor TTMSFNCWXPDFToolbarItem.Create(ACollection: TCollection);
begin
  inherited;
  FBitmap := TTMSFNCBitmap.Create;
  FPDFRole := trOpenFile;
  CanSelect := False;
  CanDeselect := False;
end;

destructor TTMSFNCWXPDFToolbarItem.Destroy;
begin
  FBitmap.Free;
  inherited;
end;

procedure TTMSFNCWXPDFToolbarItem.SetBitmap(const Value: TTMSFNCBitmap);
begin
  FBitmap.Assign(Value);
  TTMSFNCCustomListOpen(FOwner).InvalidateItems;
end;

{ TTMSFNCWXPDFToolbarItems }

function TTMSFNCWXPDFToolbarItems.Add: TTMSFNCWXPDFToolbarItem;
begin
  Result := TTMSFNCWXPDFToolbarItem(inherited Add);
end;

function TTMSFNCWXPDFToolbarItems.CreateItemClass: TCollectionItemClass;
begin
  Result := TTMSFNCWXPDFToolbarItem;
end;

function TTMSFNCWXPDFToolbarItems.GetItem(
  Index: Integer): TTMSFNCWXPDFToolbarItem;
begin
  Result := TTMSFNCWXPDFToolbarItem(inherited Items[Index]);
end;

function TTMSFNCWXPDFToolbarItems.Insert(
  Index: Integer): TTMSFNCWXPDFToolbarItem;
begin
  Result := TTMSFNCWXPDFToolbarItem(inherited Insert(Index));
end;

procedure TTMSFNCWXPDFToolbarItems.SetItem(Index: Integer;
  const Value: TTMSFNCWXPDFToolbarItem);
begin
  inherited Items[Index] := Value;
end;

{ TTMSFNCWXCustomPDFToolbar }

constructor TTMSFNCWXCustomPDFToolbar.Create(AOwner: TComponent);
begin
  inherited;
  Height := 40;
  Width := 500;
  Appearance.ItemWidth := 35;
  if Orientation = toHorizontal then
    Columns := 100
  else
    Rows := 100;

  if csDesigning in ComponentState then
    InitializeDefault;
end;

function TTMSFNCWXCustomPDFToolbar.CreateItemsCollection: TTMSFNCCustomListItems;
begin
  Result := TTMSFNCWXPDFToolbarItems.Create(Self);
end;

procedure TTMSFNCWXCustomPDFToolbar.DisableAllButtons;
var
  I: Integer;
begin
  BeginUpdate;
  for I := 0 to Items.Count - 1 do
    Items[I].Enabled := False;
  EndUpdate;
end;

procedure TTMSFNCWXCustomPDFToolbar.ChangeButtonState(AEnabled: Boolean;
  AButtonRoles: TTMSFNCWXPDFToolbarItemRoles);
var
  I: Integer;
begin
  BeginUpdate;
  for I := 0 to Items.Count - 1 do
  begin
    if (Items[I] as TTMSFNCWXPDFToolbarItem).PDFRole in AButtonRoles then
      Items[I].Enabled := AEnabled;
  end;
  EndUpdate;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCWXCustomPDFToolbar.DoDialogPDFChanged(Sender: TObject);
begin
  (Sender as TWebOpenDialog).Files[0].GetFileAsBase64;
end;

procedure TTMSFNCWXCustomPDFToolbar.DoDialogFileBase64(Sender: TObject;
  AFileIndex: Integer; ABase64: string);
begin
  Viewer.LoadFromBase64(ABase64);
end;
{$ENDIF}

procedure TTMSFNCWXCustomPDFToolbar.DoItemClick(AItemIndex: Integer);
var
  r: TTMSFNCWXPDFToolbarItemRole;
  fn: string;
  {$IFDEF WEBLIB}
  w: TWebOpenDialog;
  {$ENDIF}
begin
  inherited;
  if not Assigned(Viewer) then
    Exit;

  r := (Items[AItemIndex] as TTMSFNCWXPDFToolbarItem).PDFRole;
  case r of
    trOpenFile:
    begin
      {$IFNDEF WEBLIB}
      if TTMSFNCUtils.SelectFile(fn) then
      begin
        Viewer.LoadFromFile(fn);
        DisableAllButtons;
      end;
      {$ENDIF}
      {$IFDEF WEBLIB}
      w := TWebOpenDialog.Create(Self);
      w.Accept := '.pdf,application/pdf';
      w.OnChange := @DoDialogPDFChanged;
      w.OnGetFileAsBase64 := DoDialogFileBase64;
      w.Execute;
      {$ENDIF}
    end;
    trFirstPage: Viewer.ShowPage(1);
    trPreviousPage: Viewer.PreviousPage;
    trNextPage: Viewer.NextPage;
    trLastPage: Viewer.ShowPage(Viewer.PageCount);
    trZoomIn: Viewer.ZoomIn;
    trZoomOut: Viewer.ZoomOut;
    trRotateLeft: Viewer.TurnAngleLeft;
    trRotateRight: Viewer.TurnAngleRight;
    trCustom:
    begin
      if Assigned((Items[AItemIndex] as TTMSFNCWXPDFToolbarItem).OnCustomEvent) then
        (Items[AItemIndex] as TTMSFNCWXPDFToolbarItem).OnCustomEvent((Items[AItemIndex] as TTMSFNCWXPDFToolbarItem));
    end;
  end;
end;

procedure TTMSFNCWXCustomPDFToolbar.DoItemDrawContent(
  AGraphics: TTMSFNCGraphics; ARecT: TRectF; AItem: TTMSFNCCustomListItem);
var
  bmp: TTMSFNCBitmap;
begin
  inherited;
  InflateRectEx(ARect, ScalePaintValue(-5), ScalePaintValue(-5));
  if not IsBitmapEmpty((AItem as TTMSFNCWXPDFToolbarItem).Bitmap) then
    AGraphics.DrawBitmap(ARect,(AItem as TTMSFNCWXPDFToolbarItem).Bitmap)
  else
  begin
    bmp := nil;
    case (AItem as TTMSFNCWXPDFToolbarItem).PDFRole of
      trOpenFile:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBAROPEN', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBAROPEN, HInstance));
        {$ENDIF}
      end;
      trFirstPage:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARFIRST', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARFIRST, HInstance));
        {$ENDIF}
      end;
      trPreviousPage:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARPREV', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARPREV, HInstance));
        {$ENDIF}
      end;
      trNextPage:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARNEXT', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARNEXT, HInstance));
        {$ENDIF}
      end;
      trLastPage: begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARLAST', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARLAST, HInstance));
        {$ENDIF}
      end;
      trZoomIn:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARZOOMIN', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARZOOMIN, HInstance));
        {$ENDIF}
      end;
      trZoomOut:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARZOOMOUT', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARZOOMOUT, HInstance));
        {$ENDIF}
      end;
      trRotateLeft:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARROTLEFT', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARROTLEFT, HInstance));
        {$ENDIF}
      end;
      trRotateRight:
      begin
        {$IFNDEF WEBLIB}
        bmp := TTMSFNCBitmap.CreateFromResource('TMSFNCWXPDFTOOLBARROTRIGHT', HInstance);
        {$ENDIF}
        {$IFDEF WEBLIB}
        bmp := TTMSFNCBitmap(TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARROTRIGHT, HInstance));
        {$ENDIF}
      end;
    end;
    if Assigned(bmp) then
    begin
      try
        AGraphics.DrawBitmap(ARect, bmp);
      finally
        bmp.Free;
      end;
    end;
  end;
end;

procedure TTMSFNCWXCustomPDFToolbar.DoPDFLoaded(Sender: TObject;
  NumPages: Integer);
begin
  EnableDefaultButtons;

  if Assigned(FOldLoaded) then
    FOldLoaded(Sender, NumPages);
end;

procedure TTMSFNCWXCustomPDFToolbar.DoPDFShowPage(Sender: TObject;
  APageNumber: Integer);
var
  s: TTMSFNCWXPDFToolbarItemRoles;
begin
  if APageNumber = 1 then
  begin
    s := [trFirstPage, trPreviousPage];
    if APageNumber = Viewer.PageCount then
      s := s + [trLastPage, trNextPage];

    ChangeButtonState(False, s);

    if APageNumber <> Viewer.PageCount then
      ChangeButtonState(True, [trLastPage, trNextPage]);
  end
  else if APageNumber = Viewer.PageCount then
  begin
    ChangeButtonState(False, [trLastPage, trNextPage]);
    ChangeButtonState(True, [trPreviousPage, trFirstPage])
  end
  else
    ChangeButtonState(True, [trFirstPage, trPreviousPage, trLastPage, trNextPage]);

  if Assigned(FOldShowPage) then
    FOldShowPage(Sender, APageNumber);
end;

procedure TTMSFNCWXCustomPDFToolbar.EnableDefaultButtons;
var
  I: Integer;
begin
  BeginUpdate;
  for I := 0 to Items.Count - 1 do
  begin
    if (Items[I] as TTMSFNCWXPDFToolbarItem).PDFRole in [trFirstPage, trPreviousPage] then
      Items[I].Enabled := False
    else if ((Items[I] as TTMSFNCWXPDFToolbarItem).PDFRole in [trLastPage, trNextPage]) and (Viewer.PageCount < 2) then
      Items[I].Enabled := False
    else if ((Items[I] as TTMSFNCWXPDFToolbarItem).PDFRole in [trZoomIn, trZoomOut, trRotateLeft, trRotateRight]) and (Viewer.PageCount < 1) then
      Items[I].Enabled := False
    else
      Items[I].Enabled := True;
  end;
  EndUpdate;
end;

function TTMSFNCWXCustomPDFToolbar.GetDocURL: string;
begin
  Result := 'https://download.tmssoftware.com/doc/tmsfncwxpack/components/ttmsfncwxpdftoolbar/';
end;

function TTMSFNCWXCustomPDFToolbar.GetItems: TTMSFNCWXPDFToolbarItems;
begin
  Result := (inherited Items) as TTMSFNCWXPDFToolbarItems;
end;

function TTMSFNCWXCustomPDFToolbar.GetVersion: string;
begin
  Result := GetVersionNumber(MAJ_VER, MIN_VER, REL_VER, BLD_VER);
end;

procedure TTMSFNCWXCustomPDFToolbar.InitializeDefault;
  procedure CreateToolbarItem(ARole: TTMSFNCWXPDFToolbarItemRole);
  var
    itm: TTMSFNCWXPDFToolbarItem;
  begin
    itm := (Items.Add as TTMSFNCWXPDFToolbarItem);
    itm.PDFRole := ARole;
    itm.CanSelect := False;
    itm.Enabled := False;
  end;
begin
  BeginUpdate;

  CreateToolbarItem(trOpenFile);
  CreateToolbarItem(trFirstPage);
  CreateToolbarItem(trPreviousPage);
  CreateToolbarItem(trNextPage);
  CreateToolbarItem(trLastPage);
  CreateToolbarItem(trZoomOut);
  CreateToolbarItem(trZoomIn);
  CreateToolbarItem(trRotateLeft);
  CreateToolbarItem(trRotateRight);

  if Assigned(Viewer) and (Viewer.PageCount > 0) then
    EnableDefaultButtons;

  EndUpdate;
end;

procedure TTMSFNCWXCustomPDFToolbar.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  inherited;
  if (Operation = opRemove) and (AComponent = Viewer) then
    FViewer := nil;
end;

procedure TTMSFNCWXCustomPDFToolbar.SetItems(
  const Value: TTMSFNCWXPDFToolbarItems);
begin
  Items.Assign(Value);
end;

procedure TTMSFNCWXCustomPDFToolbar.SetOrientation(
  const Value: TTMSFNCCustomListOrientation);
var
  iwh: Single;
  prev: TTMSFNCCustomListOrientation;
begin
  prev := Orientation;
  if Orientation = toHorizontal then
    iwh := Appearance.ItemWidth
  else
    iwh := Appearance.ItemHeight;

  inherited;

  if prev <> Value then
  begin
    if Value = toHorizontal then
    begin
      Appearance.ItemWidth := iwh;
      Columns := 100;
    end
    else
    begin
      Appearance.ItemHeight := iwh;
      Rows := 100;
    end;
  end;
end;

procedure TTMSFNCWXCustomPDFToolbar.SetViewer(const Value: TTMSFNCWXPDFViewer);
begin
  if FViewer <> Value then
  begin
    FViewer := Value;
    if Assigned(Viewer) then
    begin
      FOldLoaded := Viewer.OnLoaded;
      Viewer.OnLoaded := {$IFDEF LCLLIB}@{$ENDIF}DoPDFLoaded;

      FOldShowPage := TTMSFNCWXPDFViewerOpen(Viewer).OnShowPage;
      TTMSFNCWXPDFViewerOpen(Viewer).OnShowPage := {$IFDEF LCLLIB}@{$ENDIF}DoPDFShowPage;

      EnableDefaultButtons;
    end
    else
    begin
      FOldLoaded := nil;
      FOldShowPage := nil;

      DisableAllButtons;
    end;
  end;
end;

{ TTMSFNCWXPDFToolbar }

procedure TTMSFNCWXPDFToolbar.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCWXPDFToolbar);
end;

{$IFDEF WEBLIB}
initialization
begin
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBAROPEN);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARFIRST);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARPREV);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARNEXT);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARLAST);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARZOOMOUT);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARZOOMIN);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARROTLEFT);
  TTMSFNCBitmap.CreateFromResource(TMSFNCWXPDFTOOLBARROTRIGHT);
end;
{$ENDIF}

end.
